import { Five9Data } from '../types'

export const buildFive9CallUrl = (
  phoneNumber: string,
  { apiURL, campaignName, orgID }: Omit<Five9Data, 'userID'>
): string => {
  return `https://${apiURL}/appsvcs/rs/svc/orgs/${orgID}/interactions/click_to_dial?number=${phoneNumber.replace(
    /(-|\(|\)|\s|\+\d+)/g,
    ''
  )}&campaignId=${campaignName.name}`
}
